import {EntityService} from '../../../../service/EntityService';

export class CityService extends EntityService {

  static entity = 'app/city';

}
